import AuthenticatedController from './AuthenticatedController';
import { VALIDATION_MESSAGE, VALIDATION_MESSAGES } from '@mm/api-routes';
import { ValidationMessageModel } from '../model/ValidationMessageModel';

export default class ValidationMessagesContoller extends AuthenticatedController {
  static getValidationMessage(
    id: number,
  ): Promise<{ data: ValidationMessageModel }> {
    return super.get(VALIDATION_MESSAGE(id));
  }

  static async getAll() {
    return super.get(VALIDATION_MESSAGES);
  }

  static postValidationMessage(
    entity,
  ): Promise<{ data: ValidationMessageModel }> {
    return super.post(VALIDATION_MESSAGES, entity);
  }

  static putValidationMessage(
    entity,
  ): Promise<{ data: ValidationMessageModel }> {
    return super.put(VALIDATION_MESSAGE(entity.id), entity);
  }

  static deleteValidationMessage(entity) {
    return super.delete(VALIDATION_MESSAGE(entity.id));
  }
}
